import React, { useState } from "react";

import ChatList from "./ChatList";

import { useAppSelector, useAppDispatch } from "../../redux/hooks";
import { updateChatDenial, getUserId } from "../../redux/reducers/user";
import { getAuthToken } from "../../redux/reducers/auth";
import {
  getLatestMessages,
  getNotifications,
  getStateChatRooms,
} from "../../redux/reducers/chat";

import { getChatSocket } from "../../services/socket/useSocket";
import SocketClientEvents from "../../services/socket/SocketClientEvents";

const ChatListContainer: React.FC = () => {
  const chatRooms = useAppSelector(getStateChatRooms);
  const chatNotifications = useAppSelector(getNotifications);
  const latestMessages = useAppSelector(getLatestMessages);
  const authToken = useAppSelector(getAuthToken);
  const userId = useAppSelector(getUserId);
  const socket = getChatSocket();
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleUpdateDenial = async (denial: boolean) => {
    if (!authToken) return;
    setIsLoading(true);
    dispatch(updateChatDenial({ auth_token: authToken, denial: denial }))
      .then(() => socket.emit(SocketClientEvents.denialUpdated, userId))
      .finally(() => setIsLoading(false));
  };

  return (
    <ChatList
      chatrooms={chatRooms}
      notifications={chatNotifications}
      latestMessages={latestMessages}
      isLoading={isLoading}
      handleUpdateDenial={handleUpdateDenial}
    />
  );
};

export default ChatListContainer;
